import React from "react";
import Layout from "@/components/Layout";
import { MILESTONES } from "@/data/bridgeData";
import { useEntries } from "@/context/EntriesContext";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, Circle } from "lucide-react";

export default function Milestones() {
  const { getEntry, saveEntry } = useEntries();
  const { user } = useAuth();
  const readOnly = false;
  const done = MILESTONES.filter((m) => getEntry(`milestone:${m.n}:done`, false)).length;

  return (
    <Layout coachContext>
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="label-eyebrow mb-3">Milestone framework</div>
          <h1 className="font-serif text-4xl sm:text-5xl font-light text-stone-900">Evidence of progress</h1>
        </div>
        <div className="text-right">
          <div className="font-serif text-5xl text-brand-primary">{done}<span className="text-stone-300">/6</span></div>
          <div className="text-xs text-stone-500">reached</div>
        </div>
      </div>

      <div className="relative space-y-5">
        {MILESTONES.map((m) => {
          const key = `milestone:${m.n}:done`;
          const isDone = getEntry(key, false);
          const noteKey = `milestone:${m.n}:note`;
          return (
            <div key={m.n} className={`rounded-sm border p-7 transition-all duration-300 ${isDone ? "border-brand-sage/50 bg-brand-sage/5" : "border-stone-200 bg-white"}`}>
              <div className="flex items-start gap-4">
                <button
                  data-testid={`milestone-mark-${m.n}`}
                  onClick={() => saveEntry(key, !isDone, true)}
                  className="mt-0.5 shrink-0 transition-transform hover:scale-110"
                >
                  {isDone ? <CheckCircle2 size={24} className="text-brand-sage" /> : <Circle size={24} className="text-stone-300" />}
                </button>
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <span className="label-eyebrow">Milestone {m.n}</span>
                  </div>
                  <h3 className="font-serif text-2xl text-stone-900 mt-0.5">{m.title}</h3>
                  <ul className="mt-3 flex flex-wrap gap-2">
                    {m.evidence.map((ev) => (
                      <li key={ev} className="rounded-full border border-stone-200 bg-white px-3 py-1 text-xs text-stone-600">{ev}</li>
                    ))}
                  </ul>
                  <textarea
                    data-testid={`milestone-note-${m.n}`}
                    value={getEntry(noteKey, "")}
                    onChange={(e) => saveEntry(noteKey, e.target.value)}
                    rows={2}
                    placeholder="Notes on what makes this true…"
                    className="mt-4 w-full resize-y bg-transparent border-b border-stone-200 py-1.5 text-sm text-stone-700 focus:outline-none focus:border-brand-primary transition-colors"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}
